import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { PrivateRoute } from './components/PrivateRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Services from './pages/Services';
import ServiceForm from './pages/ServiceForm';
import Portfolio from './pages/Portfolio';
import PortfolioForm from './pages/PortfolioForm';
import Categories from './pages/Categories';
import CategoryForm from './pages/CategoryForm';
import News from './pages/News';
import NewsForm from './pages/NewsForm';
import Team from './pages/Team';
import TeamForm from './pages/TeamForm';
import Company from './pages/Company';
import VisionMission from './pages/VisionMission';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import LegalPage from './pages/LegalPage';
import CertificationsPage from './pages/CertificationsPage';
import CareersPage from './pages/CareersPage';
import 'antd/dist/reset.css';
import './admin-theme.css';

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/login" element={<Login />} />

                    <Route
                        path="/"
                        element={
                            <PrivateRoute>
                                <Layout />
                            </PrivateRoute>
                        }
                    >
                        <Route index element={<Navigate to="/dashboard" replace />} />
                        <Route path="dashboard" element={<Dashboard />} />

                        {/* Services */}
                        <Route path="services" element={<Services />} />
                        <Route path="services/new" element={<ServiceForm />} />
                        <Route path="services/edit/:id" element={<ServiceForm />} />

                        {/* Portfolio */}
                        <Route path="portfolio" element={<Portfolio />} />
                        <Route path="portfolio/new" element={<PortfolioForm />} />
                        <Route path="portfolio/edit/:id" element={<PortfolioForm />} />

                        {/* Categories */}
                        <Route path="categories" element={<Categories />} />
                        <Route path="categories/new" element={<CategoryForm />} />
                        <Route path="categories/edit/:id" element={<CategoryForm />} />

                        {/* News */}
                        <Route path="news" element={<News />} />
                        <Route path="news/new" element={<NewsForm />} />
                        <Route path="news/edit/:id" element={<NewsForm />} />

                        {/* Team */}
                        <Route path="team" element={<Team />} />
                        <Route path="team/new" element={<TeamForm />} />
                        <Route path="team/edit/:id" element={<TeamForm />} />

                        {/* Company */}
                        <Route path="company" element={<Company />} />

                        {/* Vision Mission */}
                        <Route path="vision-mission" element={<VisionMission />} />

                        {/* About */}
                        <Route path="about" element={<AboutPage />} />

                        {/* Contact */}
                        <Route path="contact" element={<ContactPage />} />

                        {/* Legal */}
                        <Route path="legal" element={<LegalPage />} />

                        {/* Certifications */}
                        <Route path="certifications" element={<CertificationsPage />} />

                        {/* Careers */}
                        <Route path="careers" element={<CareersPage />} />
                    </Route>

                    <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
